// extracted by mini-css-extract-plugin
export default {"myComponent":"FoundationContent_myComponent__aHUk4","left":"FoundationContent_left__zK2L8","right":"FoundationContent_right__2QFvU"};